import { Navigate, Outlet, useLocation } from 'react-router-dom';

import MinimalLayout from '../../layout/minimalLayout/MinimalLayout';
import React from 'react';
import { useAuthStore } from '../../../store';
import { useIsMutating } from '@tanstack/react-query';

const UnauthenticatedRoute = ({
    defaultPath = '/campaigns',
    Layout = MinimalLayout,
}) => {
    const authToken = useAuthStore((state) => state.authToken);
    const userProfile = useAuthStore((state) => state.userProfile);

    const location = useLocation();
    const isFetching = useIsMutating({ mutationKey: ['user_profile'] });
    if (authToken && isFetching) {
        return <></>;
    }

    // from or defaultPath
    const { from = defaultPath } = location?.state || {};
    return !authToken || !userProfile ? (
        Layout != null ? (
            <Layout />
        ) : (
            <Outlet />
        )
    ) : (
        <Navigate
            to={{
                pathname: from,
            }}
        />
    );
    //return Layout != null ? <Layout /> : <Outlet />;
};
export default UnauthenticatedRoute;
